import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import en from '@angular/common/locales/en';

import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthTokenInterceptor } from './core/interceptors';
import { AuthService } from './core/services';
import { AuthGuard } from './core/guards';
import { NotificationComponent, NotificationModule } from './shared/components';
import { AppConfig } from './core/configs';
import { ContactUsModule } from './modules/contact-us/contact-us.module';

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NzNotificationModule,
    NgxSpinnerModule,
    NotificationModule,
    NzModalModule,
    FormsModule,
    InfiniteScrollModule,
    NzIconModule,
    ContactUsModule], providers: [
      AppConfig,
      { provide: NZ_I18N, useValue: en_US },
      { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
      AuthGuard,
      AuthService,
      NotificationComponent,
      provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
